var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTrendingSearchIconLight = function SvgTrendingSearchIconLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.992 6.11a.867.867 0 000-.233.707.707 0 00-.055-.188 1.228 1.228 0 00-.1-.156.832.832 0 00-.156-.189l-.133-.077a.766.766 0 00-.211-.112h-.222A.778.778 0 0020.882 5h-5.553a1.11 1.11 0 000 2.221h3.143l-4.443 5.23-4.797-2.853a1.11 1.11 0 00-1.422.244l-5.553 6.663a1.111 1.111 0 101.71 1.422l4.943-5.93 4.742 2.843a1.11 1.11 0 001.41-.234l4.709-5.497v2.554a1.11 1.11 0 002.221 0V6.111z",
    fill: "#000"
  })));
};
export default SvgTrendingSearchIconLight;